import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Drafting compass (NOT a navigation compass) — geometry instrument
 *  with a hinged head, a needle leg, and a pencil leg. The faint arc
 *  at the bottom hints at a circle being scribed. */
export function IcnCompass(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="compass">
      {/* Hinge head — a small filled disk at the apex */}
      <circle cx="8" cy="3" r="0.9" fill="currentColor" stroke="none" />
      {/* Needle leg — straight to a sharp point */}
      <path d="M8 3 L4.5 13.5" />
      {/* Pencil leg — straight, slightly thicker tip suggested by the cap */}
      <path d="M8 3 L11.5 13.5" />
      {/* Pencil tip cap */}
      <path d="M11 12.5 L12 13.5 L11 14.5" />
      {/* Scribed arc */}
      <path d="M5.5 13 Q8 14.2 10.5 13" />
    </Svg>
  );
}
